import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=276e4f4e&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=276e4f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e4f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276e4f4e')) {
      api.createRecord('276e4f4e', component.options)
    } else {
      api.reload('276e4f4e', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=276e4f4e&scoped=true&", function () {
      api.rerender('276e4f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HzochjuLQivm/JS/comp/Voucher.vue"
export default component.exports